import { Inject, Injectable } from '@angular/core';
import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../config';
import { AvailabilityV2DataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';
import { IAvailV2SinglePropParams } from '../interfaces/AvailV2SinglePropParameters/IAvailV2SinglePropParams';

const CLASS_NAME = 'AvailabilityV2Dao';

@Injectable()
export class AvailabilityV2Dao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.availabilityV2DAO, new DefaultRetryHandler(), new AvailabilityV2DataValidator(), log, cookieService);
  }

  get(rateDetailsAvailV2Request: IAvailV2SinglePropParams): Observable<any> {
    const url = `${this.daoConfig.url}?fieldset=rateDetails,rateDetails.policies`;
    return super.doPost(url, rateDetailsAvailV2Request);
  }

};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/availability-v2.dao.ts